export default __webpack_public_path__ + "static/media/team2.27efbb54.JPG";